import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, Collapse } from '@material-ui/core';
import ChapterAccordionContext from './ChapterAccordionContext';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.typography.body1,
    width: '100%',
  },
}));

const ChapterAccordion = ({
  children: childrenProp,
  className,
  defaultExpanded = false,
  id,
  orientation,
  ...props
}) => {
  const [summary, ...children] = React.Children.toArray(childrenProp);
  const [expanded, setExpanded] = useState(defaultExpanded ?? false);
  const handleChange = useCallback(() => {
    setExpanded((prev) => !prev);
  }, []);

  const contextValue = React.useMemo(
    () => ({ expanded, toggle: handleChange, orientation }),
    [expanded, handleChange, orientation],
  );

  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...props}>
      <ChapterAccordionContext.Provider value={contextValue}>
        {summary}
      </ChapterAccordionContext.Provider>
      <Collapse in={expanded} timeout="auto">
        <div
          aria-labelledby={summary.props.id}
          id={summary.props['aria-controls']}
          role="region"
        >
          {expanded ? children : null}
        </div>
      </Collapse>
    </div>
  );
};
// );

ChapterAccordion.propTypes = {
  /**
   * If there are children the component will render the children in the Collapse element so their visibility can be toggled.
   */
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /**
   * Option for this element to expand the children by default.
   */
  defaultExpanded: PropTypes.bool,
  /**
   * Associates aria-controls for accordion if there are children.
   */
  id: PropTypes.string,
  /**
   * Pass 'left' so ChapterAccordionSummary will display its expand button on the left, or nothing to default to 'right' orientation
   */
  orientation: PropTypes.string,
};

export default ChapterAccordion;
